import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export const CustomTooltip = ({ active, payload, label, theme }) => {
    if (active && payload && payload.length) {
        return (
            <Paper sx={{ p: 2, backgroundColor: 'rgba(255, 255, 255, 0.98)', boxShadow: theme.shadows[3], maxWidth: 300 }}>
                <Typography 
                    variant="subtitle2" 
                    sx={{ 
                        mb: 1, 
                        color: theme.palette.text.primary,
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        lineHeight: 1.4,
                    }}
                >
                    {label}
                </Typography>
                {payload.map((entry, index) => (
                    <Box 
                        key={index} 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'flex-start', 
                            gap: 1,
                            py: 0.5,
                            flexWrap: 'nowrap'
                        }}
                    >
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: entry.color,
                                borderRadius: '50%',
                                flexShrink: 0,
                                mt: 0.5
                            }}
                        />
                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column',
                            flex: 1,
                            minWidth: 0 // Enable text truncation in flex container
                        }}>
                            <Typography 
                                variant="body2" 
                                sx={{ 
                                    color: theme.palette.text.secondary,
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal',
                                    lineHeight: 1.4,
                                }}
                            >
                                {entry.name}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                sx={{ 
                                    color: theme.palette.text.primary, 
                                    fontWeight: 500,
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {entry.value?.toFixed(1)}%
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Paper>
        );
    }
    return null;
};
